module.exports = __webpack_public_path__ + "img/404-Error-amico.8581cb8c.svg";